import React from "react";
import { Link } from "react-router-dom";
import { Unit } from "../common/api";
import { UnitItemBody } from "./UnitItemBody";
import {
  AnalyticsContext,
  FlashpackUnitCellTapEvent,
  GameUnitCellTapEvent,
  UnitCellTapEvent,
} from "../common/context/AnalyticsContext";

export enum UnitItemLoggingContext {
  None,
  Unit,
  Flashpack,
  Game,
}

export const UnitItem = ({
  unit,
  loggingContext = UnitItemLoggingContext.None,
}: {
  unit: Unit;
  loggingContext?: UnitItemLoggingContext;
}) => {
  const { logEvent } = React.useContext(AnalyticsContext);
  return (
    <Link
      to={`/courses/${unit.id}/${unit.slug}/`}
      style={{ textDecoration: "none" }}
      onClick={() => {
        switch (loggingContext) {
          case UnitItemLoggingContext.Unit:
            logEvent(new UnitCellTapEvent(unit.id, unit.title));
            break;
          case UnitItemLoggingContext.Flashpack:
            logEvent(new FlashpackUnitCellTapEvent(unit.id, unit.title));
            break;
          case UnitItemLoggingContext.Game:
            logEvent(new GameUnitCellTapEvent(unit.id, unit.title));
            break;
          case UnitItemLoggingContext.None:
            break;
        }
      }}
    >
      <UnitItemBody unit={unit} />
    </Link>
  );
};
